import React from 'react'
import styled, { css } from 'styled-components'
import breakpoints from '../../../vars/breakpoints'
import gutters from '../../../vars/gutters'
import colors from '../../../vars/colors'

export const ColorBlock = styled.div`
    position: relative;
    width: 100%;
    padding-top: 60%;
    margin-bottom: 50%;
    @media (max-width: ${breakpoints['bp-desktop']}) {
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        padding-top: 100%;
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        padding-top: 50%;
        margin-bottom: 50px;
    }
    &:hover {
        .stripesHolder {
            .stripes {
                animation-play-state: paused;
            }
        }
    }
    .stripesHolder {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        overflow: hidden;
        left: calc(${gutters['container-gutters-desktop-l']} * -0.8);
        @media (max-width: ${breakpoints['bp-desktop']}) {
            left: calc(${gutters['container-gutters-desktop']} * -0.8);
        }
        @media (max-width: ${breakpoints['bp-tablet']}) {
            left: calc(${gutters['container-gutters-tablet']} * -0.8);
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            left: calc(${gutters['container-gutters-mobile']} * -1);
            right: calc(${gutters['container-gutters-mobile']} * -1);
        }
        .stripes {
            position: absolute;
            top: -75px;
            left: -75px;
            right: -75px;
            bottom: -75px;
            animation-name: barbersPole;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            animation-duration: 1200ms;
            animation-play-state: running;
            @keyframes barbersPole {
                0% {transform: translate3d(0, 0, 0)}
                100% {transform: translate3d(0, 72px, 0)}
            }
            background: repeating-linear-gradient(-45deg, ${colors['peacock-blue']}, ${colors['peacock-blue']} 25px, rgba(255, 255, 255, 0.5) 25px, rgba(255, 255, 255, 0.5) 50px);
        }
    }
    .imageHolder {
        position: absolute;
        width: 140%;
        right: 0;
        top: 80%;
        transform-origin: center center;
        transition: transform 500ms ease-in-out;
        transform: translate3d(0,0,0);
        &.passive {
            transform: translate3d(-200%,0,0);
        }
        img {
            width: 100%;
            height: auto;
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            top: 20%;
            width: 100%;
            left: calc(${gutters['container-gutters-mobile']} * -1);
        }
    }
`

export const NominateCityButton = styled.div`
    overflow: hidden;
    display: flex;
    width: 100%;
    cursor: pointer;
    margin-top: 40px;
    max-width: 350px;
    margin-right: calc(-${gutters['container-gutters-desktop-l']} + ${gutters['column-gutters-desktop-l']} );
    height: 70px;
    background: ${colors['lipstick']};
    color: ${colors['white']};
    font-size: 18px;
    text-transform: uppercase;
    font-family: 'OneDotExt';
    flex-direction: column;
    position: relative;
    @media (max-width: ${breakpoints['bp-desktop']}) {
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        width: 45%;
        height: 54px;
        font-size: 12px;
        text-align: center;
        line-height: 1.5;
        margin: 0 auto;
        margin-top: 20px;
    }
    .buttonText {
        position: absolute;
        color: white;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    svg {
        #dominos-homepage-desktop-state2 {
            fill: #D51A35;
        }
    }
`

export const Intro = styled.div`
    font-family: 'OneDotExt', sans-serif;
    text-align: center;
    width: 100%;
    font-size: 16px;
    line-height: 2;
    letter-spacing: 1.8px;
    font-weight: bold;
    color: ${colors['peacock-blue']};
    text-transform: uppercase;
    z-index: 1;
    position: relative;
    margin-bottom: 20px;
    @media (max-width: ${breakpoints['bp-mobile']}) {
        font-size: 14px;
        margin-top: 20px;
    }
`



// WEBPACK FOOTER //
// ./src/components/modules/PizzaAd/styled-components.js